import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import ThemeToggle from "./ThemeToggle";
import { useTranslation } from "react-i18next";

function Header({ navLinks = [] }) {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = (isActive) =>
    `px-3 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 focus:outline-none focus:ring-0 ${
      isActive
        ? "bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-md scale-[1.02] ring-1 ring-orange-300/50 dark:ring-orange-200/30"
        : "text-white dark:text-slate-100 hover:bg-white/15 dark:hover:bg-slate-800"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-orange-500 dark:bg-slate-900/85 backdrop-blur-md border-b border-orange-600 dark:border-slate-700 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-y-2 min-h-16 py-2">
          <Link to="/" className="flex-shrink-0 flex items-center gap-2 rounded-lg pr-2 hover:opacity-90 transition-opacity focus:outline-none focus:ring-0">
            <div className="w-8 h-8 flex items-center justify-center">
              <img
                src="/logo192.png"
                alt=""
                className="w-full h-full object-contain rounded-full"
              />
            </div>
            <span className="text-lg font-semibold text-white dark:text-slate-100 leading-none whitespace-nowrap">
              {t("title")}
            </span>
          </Link>

          <nav className="hidden md:flex flex-1 justify-center items-center gap-1 lg:gap-2 min-w-0 mx-2">
            {navLinks.map((item) => (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => linkClass(isActive)}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="tel:+923145832291"
              className="hidden lg:inline-flex items-center gap-1.5 text-sm text-orange-50 hover:text-white whitespace-nowrap group"
            >
              <svg className="w-4 h-4 shrink-0 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a2 2 0 011.897 1.368l1.017 3.052a2 2 0 01-.454 2.06l-1.57 1.57a16 16 0 006.314 6.314l1.57-1.57a2 2 0 012.06-.454l3.052 1.017A2 2 0 0121 15.72V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span className="relative">
                <span className="absolute inset-0 bg-white/20 blur-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                <span className="relative font-semibold tracking-wide group-hover:scale-105 transition-transform duration-300">0314-5832291</span>
              </span>
            </a>
            <LanguageSwitcher />
            <ThemeToggle />
            <button
              type="button"
              className="md:hidden inline-flex p-2 rounded-lg text-white hover:bg-white/10"
              aria-expanded={mobileOpen}
              aria-label="Menu"
              onClick={() => setMobileOpen((o) => !o)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {mobileOpen ? (
          <div className="md:hidden pb-3 pt-1 border-t border-orange-400/50 dark:border-slate-600 flex flex-col gap-1">
            {navLinks.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `rounded-xl px-3 py-2.5 text-sm font-semibold focus:outline-none focus:ring-0 ${
                    isActive ? "bg-white/20 text-white" : "text-orange-50 hover:bg-white/10"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        ) : null}
      </div>
    </header>
  );
}

export default Header;
